import Title from './Title';
import Subtitle from './Subtitle';
import Label from './Label';
import Text from './Text';

export { Title, Subtitle, Label, Text };
